import { render, staticRenderFns } from "./GettingLogData.vue?vue&type=template&id=5c83a57c"
import script from "./GettingLogData.vue?vue&type=script&lang=js"
export * from "./GettingLogData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports